import FItemString from '../FItem/String';
import component from './component.vue';

export default class FInputFio extends FItemString {
  __component = component;

  constructor(props) {
    super(props);
    this.search = !!props.search;
  }

  get name() {
    return this.value.split(' ')[0] || '';
  }

  set name(value) {
    return this.value.set(`${value} ${this.firstName} ${this.middleName}`);
  }

  get firstName() {
    return this.value.split(' ')[1] || '';
  }

  set firstName(value) {
    return this.value.set(`${this.name} ${value} ${this.middleName}`);
  }

  get middleName() {
    return this.value.split(' ')[2] || '';
  }

  set middleName(value) {
    return this.value.set(`${this.name} ${this.firstName} ${value}`);
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (!value || value.split(' ').length < 2) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }
}
